<template>
  <modal
    class="editTruck"
    name="mapBranchGroupModal"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
    @opened="opened"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/deal.png" width="50px" />
          </span>
          <span v-if="this.$route.query.companyID">
            {{ $t("text.cOurBranches.mapGroup.title") }}</span
          >
          <span v-else> {{ $t("text.cOurBranches.mapGroup.title2") }}</span>
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div v-if="groups">
              <div class="mt-3 form_input_section">
                <div class="mt-3 input__block">
                  <select v-model="selectedGroup">
                    <option
                      value="selectGroup"
                      v-if="this.$route.query.companyID"
                      selected
                      disabled
                    >
                      {{ $t("text.cOurBranches.mapGroup.selectIndustryGroup") }}
                    </option>
                    <option value="selectGroup" v-else selected disabled>
                      {{ $t("text.cOurBranches.mapGroup.selectCompanyGroup") }}
                    </option>
                    <option
                      :value="group.id"
                      v-for="(group, index) in groups"
                      :key="index"
                    >
                      <span>
                        {{ group.name }}
                      </span>
                    </option>
                  </select>
                </div>
              </div>

              <div class="text-center mt-5">
                <button
                  class="add_quick_fuel_btn"
                  @click="mapBranch($event)"
                  :disabled="isButtonDisabled ? true : null"
                  :style="[
                    isButtonDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  <span v-if="this.$route.query.companyID">
                    {{ $t("text.cOurBranches.mapGroup.mapSite") }}</span
                  >
                  <span v-else>
                    {{ $t("text.cOurBranches.mapGroup.mapBranch") }}</span
                  >
                </button>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </div>
            </div>

            <div v-else>
              <p>{{ $t("text.cOurBranches.mapGroup.noGroup") }}</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "mapBranchGroupModal",
  props: ["branchId", "company", "companyID"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      formIsValid: false,
      isButtonDisabled: false,
      groups: [],
      selectedGroup: "selectGroup",
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    closeAssigBranchModals() {
      this.$modal.hide("mapBranchGroupModal");
    },
    opened() {
      this.getGroups();
    },
    getGroups() {
      this.showLoader = true;
      let url;
      if (this.$route.query.companyID) {
        url = `${configObject.apiBaseUrl}/GroupManagement/Group/${this.companyID}`;
      } else {
        url = `${configObject.apiBaseUrl}/GroupManagement/Group/${this.company.id}`;
      }
      this.axios
        .get(url, configObject.authConfig())
        .then((response) => {
          this.showLoader = false;
          response.data.forEach((data) => {
            data.value = data.id;
            data.text = data.name;
          });
          this.groups = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },

    mapBranch($event) {
      $event.preventDefault();
      if (!this.selectedGroup) {
        this.$toast.open({
          message: this.$t("text.cOurBranches.mapGroup.toastError1"),
          type: "error",
          duration: 3000,
        });
        this.formIsValid = false;
        return;
      }

      // let companyID;
      // if (localStorage.getItem("companyDetails") !== null) {
      //   companyID = JSON.parse(localStorage.getItem("companyDetails")).id;
      // }
      // this.branchId = parseInt(this.branchId);
      // this.selectedGroup = parseInt(this.selectedGroup);
      let data = Object.assign(
        {},
        { branchId: this.branchId },
        { groupId: this.selectedGroup }
      );

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/GroupManagement/PostBranchGroup`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;

          this.$toast.open({
            message: this.$t("text.cOurBranches.mapGroup.toastSuccess"),
            type: "success",
            duration: 4000,
          });
          this.closeAssigBranchModals();
          // this.$eventHub.$emit("getTrucks");
          data = "";
        })
        .catch((error) => {
          this.isButtonDisabled = false;
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.closeAssigBranchModals();
        });
    },
  },
};
</script>
